import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationConstants } from './../../shared/constants';

@Injectable()
export class AuthentificationInterceptor implements HttpInterceptor {

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {

  }

  intercept(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {

    let actualRequest: HttpRequest<any> = req;

    const applicantToken = localStorage.getItem(AuthenticationConstants.APPLICANT_TOKEN);
    const applicantExpiresAt = localStorage.getItem(AuthenticationConstants.APPLICANT_EXPIRES_AT);

    const userToken = localStorage.getItem(AuthenticationConstants.USER_TOKEN);
    const userExpiresAt = localStorage.getItem(AuthenticationConstants.USER_EXPIRES_AT);

    if (applicantToken && applicantExpiresAt && new Date() < new Date(applicantExpiresAt)) {
      const cloned = req.clone({
        headers: req.headers.set("Authorization",
          "Bearer " + applicantToken)
      });
      actualRequest = cloned;
    }
    else if (userToken && userExpiresAt && new Date() < new Date(userExpiresAt)) {
      const cloned = req.clone({
        headers: req.headers.set("Authorization",
          "Bearer " + userToken)
      });
      actualRequest = cloned;
    }

    return next.handle(actualRequest).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((error: HttpErrorResponse, _: Observable<HttpEvent<any>>) => {
        if (error.status == HttpStatusCode.Unauthorized) {
          if (applicantToken) {
            this.router.navigate(['/applicants/login'],
              { queryParams: { } });
            //{ queryParams: { return: this.activatedRoute.snapshot['_routerState'].url} });
          }
          else if (userToken) {
            this.router.navigate(['/users/login'],
              { queryParams: {} });
          }
        }
        return throwError(error);
      })
    );

  }
}
